import { Action } from 'redux';
import { PlanFilterItem, PlanFilterStateStructure } from './interfaces/plan-filter.state.interface';

/**
 * If you need additional filters, align them with the catalogue name
 * DO NOT GO CRAZY IF YOU CAN AVOID IT!!
 */
const INITIAL_STATE_STRUCTURE: PlanFilterStateStructure = {
  activeFilters: {}
};

/** ACTION CLASS */
export class PlanFilterAction implements Action {
  type: string;
  catalogueAttribute?: string;
  changedFilter?: PlanFilterItem;
}

/** ACTIONS TYPES */
const RESET_FILTERS = 'RESET_FILTERS';
const TOGGLE_FILTER_VALUE = 'TOGGLE_FILTER_VALUE';

/** ACTIONS */
export function resetFilters(): PlanFilterAction {
  return { type: RESET_FILTERS };
}
export function toggleFilterValue(catalogueAttribute: string, changedFilter: PlanFilterItem): PlanFilterAction {
  return { type: TOGGLE_FILTER_VALUE, catalogueAttribute, changedFilter };
}

/**
 * This const's value must align with the function name of the reducer,
 * will be used to access the JSON object attribute this reducer reflects
 */
export const PLAN_FILTER_REDUCER = 'PlanFilter';
export function PlanFilter(state: PlanFilterStateStructure = INITIAL_STATE_STRUCTURE, action: PlanFilterAction ) {

  const copiedState: PlanFilterStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case TOGGLE_FILTER_VALUE:
      copiedState.activeFilters[action.catalogueAttribute]
        = addOrRemoveArrayItemByCatalogueAttributeName(
          copiedState, action.catalogueAttribute, action.changedFilter
        );
      return Object.assign({}, state, copiedState);

    case RESET_FILTERS:
      return Object.assign({}, state, INITIAL_STATE_STRUCTURE);

    default:
      return state;
  }
}

const addOrRemoveArrayItemByCatalogueAttributeName = (
  copiedState: PlanFilterStateStructure,
  catalogueAttribute: string,
  changedFilter: PlanFilterItem
) => {
  /** If catalogue filter doesn't exist, add it */
  let filterValues = copiedState.activeFilters[catalogueAttribute] || [];

  if (filterValues.some(filter => filter.value === changedFilter.value)) {
    /** Remove */
    filterValues = filterValues.filter(filter => filter.value !== changedFilter.value);
  } else {
    /** Add */
    changedFilter.checked = true;
    filterValues.push(changedFilter);
  }

  return filterValues;
}
